import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CashTransferService extends DatabaseGwService {
  URL_PATH:any="/cash-transfers";
  public checkValidation(lstCaDetail){
    let isError:number=0;
    let isValid:number=0;
    lstCaDetail.forEach(element => {
      if(element.product_id ==null || element.cash_acc_id==null || element.cash_acc_coa_id==null || element.amount==null){
        isError +=1;
        element.validField +=1;
        isValid= element.validField;
      }
      
    });
     return isError<=0 && isValid<=0;
  }

  
}
